import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createBlock } from './blocks';
import { RAW_TEXT_COMPONENT, RESERVED_COMPONENT_NAMES } from './constants';
export class SlateKit {
    constructor() {
        this.settings = {};
        this.components = {};
    }
    registerComponentAdder(component) {
        this.componentAdder = component;
    }
    loadComponentAdder() {
        if (!this.componentAdder) {
            return null;
        }
        return this.componentAdder;
    }
    registerComponentWrapper(component) {
        this.componentWrapper = component;
    }
    loadComponentWrapper() {
        if (!this.componentWrapper) {
            return null;
        }
        return this.componentWrapper;
    }
    registerSlateWrapper(component) {
        this.slateWrapper = component;
    }
    loadSlateWrapper() {
        if (!this.slateWrapper) {
            return null;
        }
        return this.slateWrapper;
    }
    registerComponents(components) {
        Object.keys(components).forEach(name => {
            var _a;
            return this.registerComponent({
                name,
                Component: components[name],
                Settings: (_a = components[name]) === null || _a === void 0 ? void 0 : _a.Settings,
            });
        });
    }
    registerComponent(options) {
        const { name, Component, Settings } = options;
        const Wrapper = this.loadComponentWrapper();
        if (RESERVED_COMPONENT_NAMES.includes(name)) {
            throw new Error(`You cannot use reserved component name: ${name}`);
        }
        if (!Settings) {
            this.components[name] = createBlock({
                name,
                Wrapper,
                Component,
            });
        }
        else {
            this.settings[name] = Settings;
            this.components[name] = createBlock({
                name,
                Wrapper,
                Component,
                SettingsComponent: Settings,
            });
        }
    }
    loadComponent(options) {
        const { key, name, compiledProps, children } = options;
        const SlateComponent = this.components[name];
        if (!SlateComponent) {
            switch (name) {
                case RAW_TEXT_COMPONENT:
                    return compiledProps;
                default:
                    return React.createElement(name, Object.assign({ key }, compiledProps), ...children);
            }
        }
        return (_jsx(SlateComponent, Object.assign({}, compiledProps, { children: children }), key));
    }
    loadSettings(name) {
        const Settings = this.settings[name];
        return Settings ? _jsx(Settings, {}, void 0) : null;
    }
}
//# sourceMappingURL=slate-kit.js.map